// Returns all accounts flat (for the account picker dropdown on Bank account history).

import { useMemo } from "react";
import { ALL_ACCOUNTS_LIST } from "../pages/Accounting/ChartOfAccounts/bank-history/mockData";
import type { AccountPickerItem } from "../pages/Accounting/ChartOfAccounts/bank-history/types";

interface UseAllAccountsListReturn {
  data: AccountPickerItem[];
  loading: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useAllAccountsList(): UseAllAccountsListReturn {
  const data = useMemo(() => ALL_ACCOUNTS_LIST, []);
  return {
    data,
    loading: false,
    error: null,
    refetch: () => {},
  };
}